export function render({ node, api }) {
  const root = document.createElement('div');

  const header = document.createElement('div');
  header.className = 'ew-node-header';
  header.dataset.ewDrag = 'true';
  header.dataset.ewSelect = 'true';
  header.dataset.ewLink = 'true';

  const title = document.createElement('span');
  title.textContent = node.props?.title || 'Image Viewer';

  const anchor = document.createElement('span');
  anchor.className = 'ew-link-anchor';
  anchor.dataset.ewLink = 'true';
  anchor.title = 'Link';

  header.append(title, anchor);

  const body = document.createElement('div');
  body.className = 'ew-node-body';

  const label = document.createElement('label');
  label.textContent = node.props?.label || 'Image source';

  const media = document.createElement('div');
  media.className = 'ew-media';

  const img = document.createElement('img');
  img.alt = node.props?.alt || 'Image';

  const applySource = (src) => {
    media.innerHTML = '';
    if (!src) {
      media.appendChild(makePlaceholder('No image source'));
      return;
    }
    img.src = src;
    media.appendChild(img);
  };

  applySource(node.data?.src || node.props?.src || '');

  img.addEventListener('load', () => {
    api.emit('node:input', { id: node.id, field: 'loaded', value: true });
  });

  body.append(label, media);
  root.append(header, body);

  return {
    el: root,
    update: (next) => {
      title.textContent = next.props?.title || 'Image Viewer';
      label.textContent = next.props?.label || 'Image source';
      img.alt = next.props?.alt || 'Image';
      const src = next.data?.src || next.props?.src || '';
      if (img.getAttribute('src') !== src) applySource(src);
    }
  };
}

function makePlaceholder(text) {
  const el = document.createElement('div');
  el.className = 'ew-media-placeholder';
  el.textContent = text;
  return el;
}
